import React from 'react';
import { StyledLayout } from '../Category/styles';
import {
    ProfileContainer,
    Divider,
    MainHeader,
    ContentWrapper
} from './styles';
import PersonalSettings from './PersonalSettings';
import ChangePassword from './ChangePassword';

const Profile: React.FC = () => {

    return (
        <StyledLayout>
            <MainHeader>
                <h1>Profile</h1>
            </MainHeader>
            <ContentWrapper>
                <ProfileContainer>
                    <PersonalSettings />
                    <Divider />
                    <ChangePassword />
                </ProfileContainer>
            </ContentWrapper>
        </StyledLayout>
    );
};

export default Profile;
